import React from "react";
import { useState, useEffect, useRef } from "react";
import { Image } from "react-bootstrap";


function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navRef = useRef(null);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleClickOutside = (event) => {
        if (navRef.current && !navRef.current.contains(event.target)) {
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    useEffect(() => {
        const handleResize = () => {
            setIsMenuOpen(false);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <>
           
            <nav ref={navRef}>
            <div >
                    <Image className="logo" src={require('../Component/Images/logo-mg.png')} />
                </div>
                <div style={{ textAlign: 'center', marginLeft: '0px' }}>
                    <h3 style={{color:'#ff7043', fontWeight:'600'}}><i>SEEDLOGIX<br /><span style={{ color: 'green' }}>RESOURCES INDIA</span></i></h3>
                </div>
                <div className="menu" onClick={toggleMenu}>
                    <div className="menu-icon"></div>
                    <div className="menu-icon"></div>
                    <div className="menu-icon"></div>
                </div>

                <ul className={isMenuOpen ? "navbar-links active" : "navbar-links"}>
                    <a className="nav-link" href="/" onClick={toggleMenu}>
                        <li>HOME</li>
                    </a>
                    <a className="nav-link" href="#services" onClick={toggleMenu}>
                        <li>OUR SERVICES</li>
                    </a>
                    <a className="nav-link" href="#aboutus" onClick={toggleMenu}>
                        <li>ABOUT US</li>
                    </a>
                    <a className="nav-link" href="#contactus" onClick={toggleMenu}>
                        <li>CONTACT US</li>
                    </a>
                </ul>
            </nav>
        </>
    )
}
export default Navbar;